// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseRenewalTermPreference

export enum LeaseRenewalTermPreference {
  CUSTOM = 'CUSTOM',
  MONTH_TO_MONTH = 'MONTH_TO_MONTH',
  ONE_YEAR = 'ONE_YEAR',
  TWO_YEAR = 'TWO_YEAR',
}

export const LeaseRenewalTermPreference_values = [
  LeaseRenewalTermPreference.CUSTOM,
  LeaseRenewalTermPreference.MONTH_TO_MONTH,
  LeaseRenewalTermPreference.ONE_YEAR,
  LeaseRenewalTermPreference.TWO_YEAR,
] as const;
